import {
    FETCH_FEEDBACK_CONTENT_SUCCESS
} from "../constant";

import axios from 'axios';
import { configuredAEMUrl, getPageUrl } from '../../utils/AEMUtils';
import { FEEDBACK } from "../../utils/AEMUrls";
import Store from "../../store/store";

const fetchFeedbackContentSuccess = response => ({
    type: FETCH_FEEDBACK_CONTENT_SUCCESS,
    payload: { ...response },
});

export const fetchFeedbackContent = (url) => async (dispatch) => {
    // const { languageCode, languageName } = getAPIInvokeData();
    const memberUrl = configuredAEMUrl(url);
    const serviceResponse = await axios({
        url: memberUrl,
        method: 'GET',
        body: { isAEMDependency: true },
    });
    if (serviceResponse && serviceResponse.status === 200) {
        dispatch(fetchFeedbackContentSuccess(serviceResponse.data));
    } else {
        // console.log(serviceResponse);
        //   dispatch(logErrorMessage(serviceResponse, 'Fetch Feedback Content Service Failed'));
    }
};